export const ROUTES = {
    HOME: "home",
    ABOUT: "about",
    SERVICES: "services",
    INDUSTRIES: "industries",
    CONTACT: "contact",
};

const ROUTE_PATHS = {
    [ROUTES.HOME]: "/:lang/",
    [ROUTES.ABOUT]: "/:lang/about",
    [ROUTES.SERVICES]: "/:lang/services",
    [ROUTES.INDUSTRIES]: "/:lang/industries",
    [ROUTES.CONTACT]: "/:lang/contact",
};

export function getRoutePath(routeName, lang = "en") {
    const pathTemplate = ROUTE_PATHS[routeName];
    if (!pathTemplate) {
        console.warn(`Route "${routeName}" not found!`);
        return "/";
    }
    return pathTemplate.replace(":lang", lang);
}